export const COPY = "Modal/AdsCopy/UPDATE"
export const LOADING = "Modal/AdsCopy/LOADING"
export const COPY_ADS = "Modal/AdsCopy/COPY_ADS"

export const copyAds = adsData => ({
    type: COPY_ADS,
    payload: adsData
})